import { render, staticRenderFns } from "./CenterPagination.vue?vue&type=template&id=5f53786d&scoped=true&"
import script from "./CenterPagination.vue?vue&type=script&lang=ts&"
export * from "./CenterPagination.vue?vue&type=script&lang=ts&"
import style0 from "./CenterPagination.vue?vue&type=style&index=0&id=5f53786d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f53786d",
  null
  
)

export default component.exports